<!--
 * @Author: scg
 * @Date: 2021-12-10 14:54:44
 * @LastEditTime: 2022-03-01 10:18:43
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="fff">
    <div class="timeAll_w">
        <el-date-picker
          v-model="value1"
          class="timeAll"
          type="daterange"
          @change="getlist"
          range-separator="-"
          disabled
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-dropdown disabled @command="handleCommand" class="timeDow">
          <span
            class="el-dropdown-link"
            :style="{ color: !isChecked ? '#606266' : '#00eec3' }"
          >
            {{ $t("Last days Days", { days: days })  }}<i
              class="el-icon-caret-bottom el-icon--right"
              :style="{ color: !isChecked ? '#606266' : '#00eec3' }"
            ></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="7">{{$t('text.num1')}}</el-dropdown-item>
          <el-dropdown-item command="30">{{$t('text.num2')}}</el-dropdown-item>
          <el-dropdown-item command="60">{{$t('text.num3')}}</el-dropdown-item>
          <el-dropdown-item command="90">{{$t('text.num4')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
    </div>
    <table class="mytable">
      <tr>
        <th>{{$t('text.txt1')}}</th>
        <th>{{$t('text.txt2')}}</th>
        <th>{{$t('text.txt3')}}</th>
        <th>{{$t('text.txt4')}}</th>
        <th>{{$t('text.txt5')}}</th>
      </tr>
      <tr v-for="(val, key) in list" :key="key">
        <td>{{ val.ssid }}</td>
        <td>{{ val.name }}</td>
        <td>{{ val.time_show }}</td>
        <td>{{ val.latitude }}</td>
        <td>{{ val.longitude }}</td>
      </tr>
    </table>
    <div class="noData" v-if="list.length <= 0 && status">{{$t('text.no')}}</div>
    <div class="pagination" v-if="code > 0">
      <el-pagination
        @current-change="setPage"
         page-size="20"
        background
        layout="prev, pager, next"
        :total="code"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { Wifi } from '@/api/user'
export default {
  name: 'HelloWorld',
  data () {
    return {
      days: 7,
      key: {
        equipment_id: localStorage.getItem('systemId'),
        page: 1,
        limit: 20,
        starttime: '',
        endtime: ''
      },
      code: 0,
      value1: '', // 获取时间
      list: [],
      msg: '',
      isChecked: null,
      status: false
    }
  },
  mounted () {
    this.handleCommand()
  },
  methods: {
    handleCommand (event) {
      // let end = new Date()
      let start = new Date(2021, 0, 1);
      let end = new Date(2022,3,30);
      if (event) {
        this.days = event
        start = new Date()
        this.isChecked = true
        start.setTime(start.getTime() - 3600 * 1000 * 24 * event)
      }
      this.value1 = [start, end]
      console.log(this.value1)
      this.getlist()
    },
    setPage (e) {
      this.key.page = e
      this.getlist()
    },
    getlist (a) {
      this.status = false
      this.key.starttime =
        this.value1[0].getFullYear() +
        '-' +
        (this.value1[0].getMonth() < 9 ? '0' : '') +
        (this.value1[0].getMonth() + 1) +
        '-' +
        (this.value1[0].getDate() < 10 ? '0' : '') +
        this.value1[0].getDate()
      this.key.endtime =
        this.value1[1].getFullYear() +
        '-' +
        (this.value1[1].getMonth() < 9 ? '0' : '') +
        (this.value1[1].getMonth() + 1) +
        '-' +
        (this.value1[1].getDate() < 10 ? '0' : '') +
        this.value1[1].getDate()
      console.log(this.key)
      if (a) {
        this.key.page = a
      }
      this.list = []
      Wifi(this.key).then((adj) => {
        this.list = adj.data.list
        this.code = adj.data.count
        this.status = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
}
.pop_ul {
  float: left;
  /* width: 385px; */
  width: 419px;
  border-right: 1px solid #e1e3e6;
  background: #fff;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Text.vue